import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div>
            <div>
                <div className='bg-dark text-white text-center p-4 margin-footer'>


                    <h3>© 2021 - All Right Reserved. <br />
                        Bangladesh</h3>

                </div>
            </div>
        </div>
    );
};

export default Footer;